package native

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.darkrockstudios.libraries.mpfilepicker.FilePicker
import common.asset.ImageAsset
import component.image.FriendlyIcon
import component.image.ImageView
import feature.mediaFile.viewModel.MediaFileViewModel
import theme.ThemeColor

@OptIn(ExperimentalMaterial3Api::class)
@Composable
actual fun FilePickerView(
    id: String?,
    viewModel: MediaFileViewModel
) {
    val media = viewModel.mediaFiles.collectAsState()
    val fileType = listOf("jpg", "png")
    var showFilePicker by remember { mutableStateOf(false) }
    LaunchedEffect(key1 = Unit) {
        if (id != null) {
            viewModel.loadMedia(id)
        }
    }

    Card(
        modifier = Modifier
            .size(180.dp)
            .clip(CircleShape)
            .background(ThemeColor.shared().White, shape = RoundedCornerShape(10.dp))
            .padding(20.dp),
        onClick = { showFilePicker = true }
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(180.dp)
                .clip(RoundedCornerShape(10.dp))
                .background(ThemeColor.shared().White, shape = RoundedCornerShape(10.dp))
                .padding(0.dp),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            FilePicker(show = showFilePicker, fileExtensions = fileType) { platformFile ->
                showFilePicker = false
                // do something with the file
            }
            Box(
                modifier = Modifier
                    .size(180.dp)
                    .clip(CircleShape)
                    .padding(20.dp)
                    .background(ThemeColor.shared().White, shape = RoundedCornerShape(10.dp)),
                contentAlignment = Alignment.Center
            ) {
                if (media.value.isNotEmpty()) {
                    ImageView(id = media.value.first()._id)
                } else {
                    FriendlyIcon(name = ImageAsset.userIcon)
                }
            }
        }
    }
}